/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// Lazy load the actual icon components from utils
const LazySlackIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-slack" */ './utils').then((m) => m.SlackIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/slack/icon' },
);

const LazySlackIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-slack-borderless" */ './utils').then(
			(m) => m.SlackIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless' },
);

const LazySlackSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-slack-search-result" */ './utils').then(
			(m) => m.SlackSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon' },
);

const LazySlackAppSelectorIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-slack-app-selector" */ './utils').then(
			(m) => m.SlackAppSelectorIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const SlackIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySlackIconComponent />
	</Suspense>
);

export const SlackIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySlackIconBorderlessComponent />
	</Suspense>
);

export const SlackSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySlackSearchResultIconComponent />
	</Suspense>
);

export const SlackAppSelectorIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazySlackAppSelectorIconComponent />
	</Suspense>
);
